import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { OurProject } from 'src/app/models/firebase/our-project';
import { LandingPage } from 'src/app/models/firebase/landing-page';
import { BlogArticle } from 'src/app/models/firebase/blogArticle';
import { AuthService } from 'src/app/service/auth/auth.service';
import { LandingPageService } from 'src/app/service/landing-page/landing-page.service';
import { SocialMedia } from 'src/app/models/firebase/socialMedia';
import { GetLanguageService } from 'src/app/service/get-language/get-language.service';
import { SocialMediaEnum } from 'src/app/enums/socialMedia.enum';
import { isNullOrUndefined } from '@pineapplelab/util';
import { IMAGES_RESOLUTIONS } from 'src/app/utils/image-config';
import { Router } from '@angular/router';
import { LandingPageBanner } from 'src/app/models/firebase/landingPageBanner';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
    @ViewChild('header') header: ElementRef;
    isSticky = false;
    landingPageData: LandingPageBanner;
    projectsArray: OurProject[] = [];
    blogs: BlogArticle[] = [];
    socialMediaArray: SocialMedia[] = [];
    socialMediaEnum = SocialMediaEnum;
    socialMediaTypes = Object.values(SocialMediaEnum).filter((value) => typeof value === 'string');
    screenWidth: number;
    screenHeight: number;
    showFiller = false;
    panelOpenState = false;
    servicesLinks: { name: string; link: string; id: string }[]
    IMAGES_RESOLUTIONS = IMAGES_RESOLUTIONS;
    selectedLanguage: string;
    showLanguageVC: boolean = this.authService.getProjectIdFromHostname(window.location.hostname) === 'pineapplelab' 
    constructor(
        private authService: AuthService,
        private landingPageService: LandingPageService,
        public getLanguageService: GetLanguageService,
        private router: Router
    ) {
    }

    async ngOnInit(): Promise<void> {

        this.selectedLanguage = this.getLanguageService.currentLanguage;
        this.getLanguageService.language$.subscribe(lang => {
            this.selectedLanguage = lang;
            this.getLandingInfo();
        });
        this.getScreenSize();
    }

    async getLandingInfo() {
        this.landingPageData = await this.landingPageService.getLandingPageBanner(this.authService.projectId);

        // get service links and if the list is blank, return empty array
        if (isNullOrUndefined(this.landingPageData?.services?.list) || this.landingPageData.services?.list.length === 0) {
            this.servicesLinks = [];
            return;
        }

        this.servicesLinks = this.landingPageData?.services?.list?.map((service) => {
            if (service.show) {
                return { name: service.title, link: service.view?.link, id: service.view?.id };
            }
            return { name: '', link: '', id: '' };
        });

        this.servicesLinks = this.servicesLinks.filter((service) => service.id !== '');
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?: Event): void {
        this.screenWidth = window.innerWidth;
        this.screenHeight = window.innerHeight;
    }

    @HostListener('window:scroll', [])
    onWindowScroll() {
        const headerElement = this.header.nativeElement;
        if (window.scrollY > 0) {
            headerElement.classList.add('navbar-stick');
            this.isSticky = true;
        } else {
            headerElement.classList.remove('navbar-unstick');
            this.isSticky = false;
        }
    }

    goTo(route: string): void {
        this.router.navigate([route]);
    }

    async changeLanguage(event: any) {
        const newLang = event?.value || event;
        this.getLanguageService.changeLanguage(newLang);
        this.landingPageData = await this.landingPageService.getLandingPageBanner(this.authService.projectId);
    }
    goToLink(link: string) {
        if (link) {
            window.open(link, '_blank');
        } else {
            this.router.navigate(['/contact']);
        }

    }
    go(): string {
        if (this.showLanguageVC) {
            return '/about-us';
        } else {
            return '/job-listing';
        }
    }


    goToService(link: string, id: string) {
        this.router.navigate([`/enterprise-services/${link}/${id}`])
    }
}
